module.exports = __webpack_public_path__ + "media/src/images/photos/run-bfdd0b3c0fae5cf7c79caf5014e82bec.jpg";